<template>
    <div class="main-content">
        <Nav />
        <div class="right-container">
            <TopNav />
            <router-view />
        </div>
    </div>
</template>

<style>
@import 'assets/css/style.css';
</style>

<script>
import Nav from './components/Nav.vue'
import TopNav from './components/TopNav.vue'
export default {
    components: { Nav, TopNav },
}
</script>
